var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 1,
    viewBox: "0 0 20 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    y1: 0.5,
    x2: 20,
    y2: 0.5,
    stroke: "#014289"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeparator);
export default __webpack_public_path__ + "static/media/icon-separator.6d91ffba88155028e51248809b775e2f.svg";
export { ForwardRef as ReactComponent };